import { request } from '@pb/utils'

import { StoreSearchQuery } from './duck/types'

export const fetchFavourites = async (): Promise<any> => {
  const response = await request.get('favourites')
  return response.data
}

export const fetchFavouritesProductCodes = async (): Promise<any> => {
  const response = await request.get('favourites/productCodes', {
    use: {
      apiVersion: false,
    },
  })
  return response.data
}

export const addToFavourites = async (articleCode: string): Promise<any> => {
  const response = await request.post('favourites', { data: { articleCode } })
  return response.data
}

export const addItemToFavouritesProductCode = async (productCode: string): Promise<any> => {
  const response = await request.post('favourites/addItem', {
    use: {
      apiVersion: false,
    },
    data: { productCode },
  })
  return response.data
}

export const removeFromFavourites = async (articleCode: string): Promise<any> => {
  const response = await request.delete(`favourites/${articleCode}`)
  return response.data
}

export const removeItemFromFavouritesProductCode = async (productCode: string): Promise<any> => {
  const response = await request.post('favourites/removeItem', {
    use: {
      apiVersion: false,
    },
    data: { productCode },
  })
  return response.data
}

export const moveToFavouriteFromCart = async (variantCode: string): Promise<any> => {
  const response = await request.post('favourites/moveToFavourite', { data: { variantCode } })
  return response.data
}

export const moveToCartFromFavourites = async (
  variantCode: string,
  productCode: string,
): Promise<any> => {
  const response = await request.post('favourites/moveToCart', {
    data: { variantCode, productCode },
  })
  return response.data
}

export const deleteFavouriteItem = async (productCode: string): Promise<any> => {
  const response = await request.delete(`favourites/${productCode}`)
  return response.data
}

export const updateVariant = async (variantCode: string, articleCode: string): Promise<any> => {
  const response = await request.post('favourites', {
    data: { variantCode, articleCode },
  })
  return response.data
}

export const fetchStoreSearchResults = async ({
  countryCode,
  articleCode,
  variantCode,
  lat,
  lng,
  radiusInMeters,
  maxNumberOfStores,
  brand,
  channel,
}: StoreSearchQuery): Promise<any> => {
  const response = await request.get(
    `sis/${countryCode}/${articleCode}/${variantCode}?latitude=${lat}&longitude=${lng}&radiusinmeters=${radiusInMeters}&maxnumberofstores=${maxNumberOfStores}&brand=${brand}&channel=${channel}`,
    {
      use: {
        apiVersion: false,
      },
    },
  )
  return response.data
}

export default {
  fetchFavourites,
  fetchFavouritesProductCodes,
  addToFavourites,
  addItemToFavouritesProductCode,
  removeFromFavourites,
  removeItemFromFavouritesProductCode,
  moveToCartFromFavourites,
  moveToFavouriteFromCart,
  deleteFavouriteItem,
  updateVariant,
  fetchStoreSearchResults,
}
